import { RefObject, useMemo, useRef } from 'react';

import { AccordionActions, AccordionState } from './useTelemedicineRequestViewModel';

export const useTelemedicineAccordion = () => {
  const dayRef = useRef<AccordionActions>(null);
  const isVisitBrandRef = useRef<AccordionActions>(null);
  const requestCallRef = useRef<AccordionActions>(null);
  const ssnRef = useRef<AccordionActions>(null);
  const childInfoRef = useRef<AccordionActions>(null);
  const detailSymptomRef = useRef<AccordionActions>(null);

  const accordionRefs: Record<AccordionState, RefObject<AccordionActions>> = useMemo(
    () => ({
      [AccordionState.Days]: dayRef,
      [AccordionState.IsVisitBrand]: isVisitBrandRef,
      [AccordionState.RequestCallType]: requestCallRef,
      [AccordionState.Ssn]: ssnRef,
      [AccordionState.ChildInfo]: childInfoRef,
      [AccordionState.DetailSymptom]: detailSymptomRef,
    }),
    []
  );

  const openSection = (state: AccordionState, options?: { scroll?: boolean }) => {
    accordionRefs[state].current?.openSection(options);
  };

  const closeSection = (state: AccordionState) => {
    accordionRefs[state].current?.closeSection();
  };

  const toggleSection = (state: AccordionState) => {
    accordionRefs[state].current?.toggleSection();
  };

  return {
    accordionRefs,
    openSection,
    closeSection,
    toggleSection,
  };
};
